import { BrowserMetrics } from './browserMetrics';
import PerformanceMonitoringService from '../../services/PerformanceMonitoringService';
import store from '@/store';
// import { eventBusDebugging } from './eventBusDebugger';
// import { firestoreListenerTracker } from './firestoreSnapshotDebugger';

// interface PerformanceMetrics {
//   version: number;
//   // timestamp: string;
//   routePath: string;
//   routeName: string | null | undefined;
//   routeParams: Record<string, any>;
//   fromPath: string;
//   fromName: string | null | undefined;
//   fromParams: Record<string, any>;
//   locationId: string | null | undefined;
//   redirectCount: number;
//   eventBusListeners: {
//     eventName: string;
//     count: number;
//     type: string;  // Add type information
//   }[];  // Change to array of detailed events
//   firestoreSubscriptions: {
//     path: string;
//     count: number;
//     type: string;  // Add type information
//   }[];  // Change to array of detailed subscriptions
//   memory?: {
//     usedJSHeapSize: number;
//     totalJSHeapSize: number;
//     jsHeapSizeLimit: number;
//     heapUsagePercentage?: number;
//     resourceCount?: {
//       scripts: number;
//       stylesheets: number;
//       images: number;
//       other: number;
//     };
//     timeOrigin?: number;
//     timing?: {
//       navigationStart: number;
//       loadEventEnd: number;
//       domComplete: number;
//       domInteractive: number;
//       domContentLoadedEventEnd: number;
//     };
//     vuexStore?: {
//       totalSize: number;
//       modulesSizes: {
//         moduleName: string;
//         size: number;
//       }[];
//     };
//   };
//   debugSessionId?: string;
// }

// interface PerformanceMonitorOptions {
//   enableVuexMonitoring?: boolean;
//   enableMemoryStats?: boolean;
//   enableEventBusTracking?: boolean;
//   enableFirestoreTracking?: boolean;
//   logToConsole?: boolean;
// }

// const DEFAULT_OPTIONS: PerformanceMonitorOptions = {
//   enableVuexMonitoring: true,
//   enableMemoryStats: true,
//   enableEventBusTracking: true,
//   enableFirestoreTracking: true,
//   logToConsole: true
// };

// const MAX_PARAMS_LENGTH = 5  // Maximum number of parameters to log
// const MAX_QUERY_LENGTH = 10  // Maximum number of query parameters to log
// const MAX_STRING_LENGTH = 100  // Maximum length for string values

// export class PerformanceMonitor {
//   private static instance: PerformanceMonitor;
//   private readonly apiEndpoint: string;
//   private options: PerformanceMonitorOptions;
//   private debugSessionId?: string;
//   private redirectCount = 0

//   private constructor(options: Partial<PerformanceMonitorOptions> = {}) {
//     this.apiEndpoint = '/api/performance-metrics';
//     this.options = { ...DEFAULT_OPTIONS, ...options };
//   }

//   public static getInstance(options?: Partial<PerformanceMonitorOptions>): PerformanceMonitor {
//     if (!PerformanceMonitor.instance) {
//       PerformanceMonitor.instance = new PerformanceMonitor(options);
//     }
//     return PerformanceMonitor.instance;
//   }

//   public updateOptions(options: Partial<PerformanceMonitorOptions>): void {
//     this.options = { ...this.options, ...options };
//   }

//   // Static methods for Vuex store size calculation
//   public static getVuexStoreSize(): number {
//     if (!store) return 0;

//     const storeSize = PerformanceMonitor.calculateSize(store.state);
//     return storeSize;
//   }

//   public static getVuexStoreModules(): { moduleName: string; size: number }[] {
//     const store = PerformanceMonitor.getVueStore();
//     if (!store) return [];

//     const modulesSizes = Object.keys(store.state).map(moduleName => ({
//       moduleName,
//       size: PerformanceMonitor.calculateSize(store.state[moduleName])
//     }));

//     return modulesSizes.sort((a, b) => b.size - a.size); // Sort by size descending
//   }

//   // Static helper methods
//   private static getVueStore(): any {
//     try {
//       return (window as any)?.$nuxt?.$store || // Nuxt
//              (window as any)?.app?.$store || // Vue global
//              ((document.querySelector('#app') as any)?.__vue__?.$store); // Vue instance
//     } catch (e) {
//       console.warn('Error accessing Vue store:', e);
//       return null;
//     }
//   }

//   private static calculateSize(obj: any): number {
//     const stringify = (obj: any): string => {
//       try {
//         return JSON.stringify(obj);
//       } catch (e) {
//         return String(obj);
//       }
//     };

//     return Math.round(new Blob([stringify(obj)]).size / 1024); // Convert to KB
//   }

//   // Instance methods that use the static methods
//   public getVuexStoreSize(): number {
//     return PerformanceMonitor.getVuexStoreSize();
//   }

//   public getVuexStoreModules(): { moduleName: string; size: number }[] {
//     return PerformanceMonitor.getVuexStoreModules();
//   }

//   // Get detailed Vuex store information including total size and module sizes
//   public getVuexStoreDetails(): { totalSize: number; modulesSizes: { moduleName: string; size: number }[] } {
//     const store = PerformanceMonitor.getVueStore();
//     if (!store) {
//       return {
//         totalSize: 0,
//         modulesSizes: []
//       };
//     }

//     const totalSize = PerformanceMonitor.calculateSize(store.state);
//     const modulesSizes = PerformanceMonitor.getVuexStoreModules();

//     return {
//       totalSize,
//       modulesSizes
//     };
//   }

//   private isMemoryAPIAvailable(): boolean {
//     return (
//       typeof performance !== 'undefined' &&
//       'memory' in performance &&
//       (performance as any).memory?.usedJSHeapSize !== undefined
//     );
//   }

//   private getTimingMetrics() {
//     const timing = performance.timing || {};
//     return {
//       navigationStart: timing.navigationStart || 0,
//       loadEventEnd: timing.loadEventEnd || 0,
//       domComplete: timing.domComplete || 0,
//       domInteractive: timing.domInteractive || 0,
//       domContentLoadedEventEnd: timing.domContentLoadedEventEnd || 0
//     };
//   }

//   private getMemoryUsage(): PerformanceMetrics['memory'] | undefined {
//     let chromeMemoryMetrics = {
//       usedJSHeapSize: 0,
//       totalJSHeapSize: 0,
//       jsHeapSizeLimit: 0,
//       heapUsagePercentage: 0
//     };

//     try {
//       const baseMetrics = {
//         resourceCount: {
//           scripts: document.scripts.length,
//           stylesheets: document.styleSheets.length,
//           images: document.images.length,
//           other: performance.getEntriesByType('resource').length
//         },
//         timeOrigin: performance.timeOrigin,
//         timing: this.getTimingMetrics()
//       };

//       let vuexStore;
//       if (this.options.enableVuexMonitoring) {
//         // Use the new method to get Vuex store details
//         const storeDetails = this.getVuexStoreDetails();
//         vuexStore = {
//           totalSize: storeDetails.totalSize,
//           modulesSizes: storeDetails.modulesSizes
//         };
//       }

//       if (this.isMemoryAPIAvailable()) {
//         const memory = (performance as any).memory;
//         chromeMemoryMetrics = {
//           usedJSHeapSize: Math.round(memory.usedJSHeapSize / 1024), // Convert to KB
//           totalJSHeapSize: Math.round(memory.totalJSHeapSize / 1024),
//           jsHeapSizeLimit: Math.round(memory.jsHeapSizeLimit / 1024),
//           heapUsagePercentage: (memory.usedJSHeapSize / memory.jsHeapSizeLimit) * 100,
//         };
//       }

//       return {
//         ...baseMetrics,
//         ...chromeMemoryMetrics,
//         vuexStore
//       };

//     } catch (e) {
//       console.warn('[DEBUG][PERF] Error collecting memory metrics:', e);
//       return undefined;
//     }
//   }

//   private formatBytes(bytes: number): string {
//     if (bytes < 1024) return bytes + ' B';
//     if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(2) + ' KB';
//     if (bytes < 1024 * 1024 * 1024) return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
//     return (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
//   }

//   private formatMetricsForLogging(metrics: PerformanceMetrics): void {
//     console.groupCollapsed('[DEBUG] [PERF] Performance Metrics');

//     // Format Event Bus Listeners for table
//     if (metrics.eventBusListeners.length > 0) {
//       console.groupCollapsed('🎯 Event Bus Listeners');
//       console.table(metrics.eventBusListeners
//         .filter(listener => listener.count > 0)
//         .sort((a, b) => b.count - a.count) // Sort by count descending
//         .map(listener => ({
//           Type: listener.type,
//           Event: listener.eventName,
//           'Listener Count': listener.count
//       })));
//       console.groupEnd();
//     }

//     // Format Firestore Subscriptions for table
//     if (metrics.firestoreSubscriptions.length > 0) {
//       console.groupCollapsed('🔥 Firestore Subscriptions');
//       console.table(metrics.firestoreSubscriptions
//         .filter(listener => listener.count > 0)
//         .sort((a, b) => b.count - a.count) // Sort by count descending
//         .map(sub => ({
//           Type: sub.type,
//           Path: sub.path,
//           'Subscription Count': sub.count
//         })));
//       console.groupEnd();
//     }

//     // Format Memory Usage
//     if (metrics.memory) {
//       console.groupCollapsed('💾 Memory Usage');
//       console.table({
//         'Used Heap': this.formatBytes(metrics.memory.usedJSHeapSize),
//         'Total Heap': this.formatBytes(metrics.memory.totalJSHeapSize),
//         'Heap Limit': this.formatBytes(metrics.memory.jsHeapSizeLimit),
//         'Heap Usage': `${metrics.memory.heapUsagePercentage?.toFixed(1)}%`
//       });

//       // Resource Counts
//       if (metrics.memory.resourceCount) {
//         console.groupCollapsed('📊 Resource Counts');
//         console.table(metrics.memory.resourceCount);
//         console.groupEnd();
//       }

//       // Vuex Store Sizes
//       if (metrics.memory.vuexStore) {
//         console.groupCollapsed('📦 Vuex Store Sizes');
//         console.table(metrics.memory.vuexStore.modulesSizes.map(module => ({
//           Module: module.moduleName,
//           Size: this.formatBytes(module.size)
//         })));
//         console.groupEnd();
//       }

//       // Add Timing Metrics
//       if (metrics.memory.timing) {
//         console.groupCollapsed('⏱️ Timing Metrics');
//         const timing = metrics.memory.timing;
//         const navigationStart = timing.navigationStart;
//         console.table({
//           'Page Load Time': `${timing.loadEventEnd - navigationStart}ms`,
//           'DOM Complete': `${timing.domComplete - navigationStart}ms`,
//           'DOM Interactive': `${timing.domInteractive - navigationStart}ms`,
//           'DOM Content Loaded': `${timing.domContentLoadedEventEnd - navigationStart}ms`
//         });
//         console.groupEnd();
//       }

//       if (metrics.memory.timeOrigin) {
//         console.log('🕒 Time Origin:', new Date(metrics.memory.timeOrigin).toISOString());
//       }

//       console.groupEnd();
//     }

//     // Route Information
//     console.groupCollapsed('🛣️ Route Information');
//     console.table({
//       'Current Route': `${metrics.routeName || 'unnamed'} (${metrics.routePath})`,
//       'Previous Route': `${metrics.fromName || 'unnamed'} (${metrics.fromPath})`,
//       'Location ID': metrics.locationId || 'N/A'
//     });
//     console.groupEnd();

//     console.groupEnd(); // End the main group
//   }

//   public setSessionId(sessionId: string): void {
//     this.debugSessionId = sessionId;
//   }

//   private trimObject = (obj: Record<string, any>, type: 'params' | 'query' = 'params'): Record<string, any> => {
//     try {
//       if (!obj) return {}

//       const maxLength = type === 'query' ? MAX_QUERY_LENGTH : MAX_PARAMS_LENGTH;

//       try {
//         const trimmedEntries = Object.entries(obj)
//           .slice(0, maxLength)
//           .map(([key, value]) => {
//             try {
//               if (typeof value === 'string') {
//                 return [key, value.slice(0, MAX_STRING_LENGTH)]
//               }
//               if (Array.isArray(value)) {
//                 return [key, value.slice(0, maxLength).map(item => {
//                   try {
//                     return typeof item === 'string' ? item.slice(0, MAX_STRING_LENGTH) : item
//                   } catch (arrayItemError) {
//                     console.warn(`Error processing array item for key ${key}:`, arrayItemError)
//                     return item
//                   }
//                 })]
//               }
//               return [key, value]
//             } catch (entryError) {
//               console.warn(`Error processing entry for key ${key}:`, entryError)
//               return [key, value]
//             }
//           })

//         return Object.fromEntries(trimmedEntries)
//       } catch (processingError) {
//         console.warn('Error processing object entries:', processingError)
//         return obj
//       }
//     } catch (error) {
//       console.warn('Error in trimObject:', error)
//       return obj // Return original object if anything fails
//     }
//   }

//   collectMetrics(route: any, fromRoute: any): PerformanceMetrics {
//     try {
//       // Only collect the specific route properties we need
//       const safeRoute = {
//         name: route?.name,
//         path: route?.path,
//         params: this.trimObject(route?.params || {}, 'params'),
//         matched: route?.matched?.map((m: any) => ({ path: m.path }))
//       };

//       const safeFromRoute = {
//         name: fromRoute?.name,
//         path: fromRoute?.path,
//         params: this.trimObject(fromRoute?.params || {}, 'params'),
//         matched: fromRoute?.matched?.map((m: any) => ({ path: m.path }))
//       };

//       const metrics: PerformanceMetrics = {
//         version: 1,
//         debugSessionId: this.debugSessionId,
//         routePath: this.getNormalizedPath(safeRoute),
//         routeName: safeRoute.name,
//         routeParams: safeRoute.params,
//         fromPath: this.getNormalizedPath(safeFromRoute),
//         fromName: safeFromRoute.name,
//         fromParams: safeFromRoute.params,
//         locationId: safeRoute.params?.locationId || safeRoute.params?.location_id,
//         redirectCount: this.redirectCount,
//         eventBusListeners: this.options.enableEventBusTracking ?
//           Object.entries(eventBusDebugging.getListenerCounts())
//             .map(([eventName, count]) => ({
//               eventName,
//               count,
//               type: eventName.split('.')[0]
//             })) : [],
//         firestoreSubscriptions: this.options.enableFirestoreTracking ?
//           Object.entries(firestoreListenerTracker.getListenerCounts())
//             .map(([path, count]) => ({
//               path,
//               count,
//               type: path.split('/')[0]
//             })) : [],
//         memory: this.options.enableMemoryStats ? this.getMemoryUsage() : undefined
//       };

//       // Only format and log metrics if logToConsole is enabled
//       if (this.options.logToConsole) {
//         this.formatMetricsForLogging(metrics);
//       }

//       return metrics;
//     } catch (error) {
//       console.error('[DEBUG][PERF] Critical error in collectMetrics:', error);
//       return {
//         version: 1,
//         routePath: '',
//         routeName: null,
//         routeParams: {},
//         fromPath: '',
//         fromName: null,
//         fromParams: {},
//         locationId: null,
//         redirectCount: this.redirectCount,
//         eventBusListeners: [],
//         firestoreSubscriptions: []
//       };
//     }
//   }

//   sendMetrics(metrics: PerformanceMetrics): void {
//     try {
//       // Original send logic
//       PerformanceMonitoringService.monitoringPerformance(metrics);
//     } catch (error) {
//       console.error('Failed to send performance metrics:', error);
//     }
//   }

//   registerPerformanceMetrics() {
//     if (typeof window !== 'undefined') {
//         (window as any).collectPerformanceMetrics = (route?: any, fromRoute?: any) => {
//           // Use type assertion to avoid TypeScript error
//           const vm = (window as any)?.$app?.__vue__ ||
//             ((document.querySelector('#app') as any)?.__vue__);

//           const router = vm?.$router;

//           this.collectMetrics(
//             route || router?.currentRoute,
//             fromRoute || router?.currentRoute
//           );
//       }
//     }
//   }
// }

// export const performanceMonitor = PerformanceMonitor.getInstance()
export class PerformanceMonitor {
  private static currentMetrics: any;
  private static getNormalizedPath(route: any): string {
    if (!route?.matched?.length) return route?.path || '';

    // Get the matched route pattern from the last matched route
    const matchedRoute = route.matched[route.matched.length - 1];
    return matchedRoute.path || route.path;
  }

  public static sendMetrics(route: any, fromRoute: any, debugSessionId: string): void {
    try {
      // Original send logic

      // Only collect the specific route properties we need
      const safeRoute = {
        name: route?.name,
        path: route?.path,
        matched: route?.matched?.map((m: any) => ({ path: m.path })),
        params: route?.params || {}
      };

      const safeFromRoute = {
        name: fromRoute?.name,
        path: fromRoute?.path,
        matched: fromRoute?.matched?.map((m: any) => ({ path: m.path })),
        params: fromRoute?.params || {}
      };

      const browserMetrics = BrowserMetrics.getBrowserMetrics()

      const data: any = {
        version: 1,
        debugSessionId: debugSessionId,
        routePath: this.getNormalizedPath(safeRoute),
        routeName: safeRoute.name,
        fromPath: this.getNormalizedPath(safeFromRoute),
        fromName: safeFromRoute.name,
        locationId: safeRoute.params?.locationId || safeRoute.params?.location_id,
        userId: store.state.user?.user?.id,
        ...browserMetrics
      }

      try
      {
        if (safeRoute.name != safeFromRoute.name) {
          data.routeBasedMemoryUsage = {
            diff: browserMetrics.memory?.usedJSHeapSize ? browserMetrics.memory.usedJSHeapSize - (this.currentMetrics?.memory?.usedJSHeapSize || 0) : 0,
            before: this.currentMetrics?.memory?.usedJSHeapSize,
            after: browserMetrics.memory?.usedJSHeapSize
          }
        }
        this.currentMetrics = browserMetrics;
      } catch (error) {
        console.error('Failed to calculate route based memory usage:', error);
      }
      PerformanceMonitoringService.monitoringPerformance(data);
    } catch (error) {
      console.error('Failed to send performance metrics:', error);
    }
  }
}